/* eslint-disable i18next/no-literal-string */
export default function FleetSmallBusiness() {
  return (
    <div className="p-12">
      <h1 className="text-2xl font-bold">Small Business</h1>
    </div>
  );
}
